import { types } from 'mobx-state-tree';
import { ConfigurationSchema } from '@jbrowse/core/configuration';
import { baseLinearDisplayConfigSchema } from '@jbrowse/plugin-linear-genome-view';
/**
 * #config LinearArcDisplay
 */
export function configSchemaFactory(pluginManager) {
    return ConfigurationSchema('LinearArcDisplay', {
        /**
         * #slot
         */
        renderer: types.optional(pluginManager.pluggableConfigSchemaType('renderer'), { type: 'ArcRenderer' }),
    }, {
        /**
         * #baseConfiguration
         */
        baseConfiguration: baseLinearDisplayConfigSchema,
        explicitlyTyped: true,
    });
}
